import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ProgressBar, ProgressIndicator } from '../../../../atoms/ProgressBar';
import { withDefaultComponentProps } from '../../../../decorators/withDefaultComponentProps';
import toastTypes from '../toastTypes';
const COMPONENT_NAME = 'ToastProgressBar';
class ToastProgressBar extends Component {
    constructor(props){
        super(props);
        this.state = {
            percent: 100
        };
        this.intervalId = null;
    }
    componentDidMount() {
        const distance = 100 / (this.props.duration / 100);
        this.intervalId = setInterval(()=>{
            const percent = this.state.percent - distance;
            this.setState({
                percent: percent > 0 ? percent : 0
            });
        }, 100);
    }
    componentDidUpdate() {
        if (this.state.percent <= 0 && this.intervalId) {
            clearTimeout(this.intervalId);
        }
    }
    componentWillUnmount() {
        if (this.intervalId) {
            clearTimeout(this.intervalId);
        }
    }
    resolveProgressIndicator() {
        switch(this.props.type){
            case toastTypes.INFO:
                return ProgressIndicator.type.INFO;
            case toastTypes.WARNING:
                return ProgressIndicator.type.WARN;
            case toastTypes.ERROR:
                return ProgressIndicator.type.ERROR;
            case toastTypes.SUCCESS:
                return ProgressIndicator.type.SUCCESS;
            default:
                return null;
        }
    }
    render() {
        return /*#__PURE__*/ React.createElement(ProgressBar, {
            progressClassName: "Toast-progressBar",
            percentage: this.state.percent,
            type: this.resolveProgressIndicator()
        });
    }
}
ToastProgressBar.propTypes = {
    duration: PropTypes.number.isRequired,
    type: PropTypes.oneOf(toastTypes.values())
};
export { ToastProgressBar };
export default withDefaultComponentProps(COMPONENT_NAME, {
    type: 'info'
}, ToastProgressBar);
